import angular from "angular";

// side-bar-data-table
angular
    .module('ui-common')
    .directive("sideBarDataTable", () => ({
        restrict: 'E',
        replace: false,
        scope: {
            view: '@',
            reportsService: '=',
            sessionService: '=',
            formatLocation: '=',
            secondsService: '=',
            isOrs: "<",
            accountIsTopParent: "<",
        },
        template: require('./side-bar-data-table-directive.html'),
        controller: ThisDirectiveController,
        controllerAs: 'vm'
    }));

ThisDirectiveController.$inject = ['TemperatureUtilsService'];

function ThisDirectiveController(TemperatureUtilsService) {
    const vm = this;
    vm.getTemperatureC = (report) => TemperatureUtilsService.getTemperatureC(report);
    vm.getTemperatureF = (report) => TemperatureUtilsService.getTemperatureF(report);

    const alarmsSignature = (alarms, labelFn) => {
        if (!alarms) {
            return '';
        }
        let sig = '';
        for (const alarm of alarms) {
            sig += labelFn(alarm) + '\n';
        }
        return sig;
    };

    const buildUniqueMemo = (labelFn) => {
        const cache = new WeakMap();
        return (alarms) => {
            if (!alarms) {
                return [];
            }
            const sig = alarmsSignature(alarms, labelFn);
            const cached = cache.get(alarms);
            if (cached && cached.sig === sig) {
                return cached.out;
            }
            const seen = new Set();
            const out = [];
            for (const alarm of alarms) {
                const key = labelFn(alarm);
                if (key && !seen.has(key)) {
                    seen.add(key);
                    out.push(alarm);
                }
            }
            out.sort((a, b) => labelFn(a).toLowerCase().localeCompare(labelFn(b).toLowerCase()));
            cache.set(alarms, { sig, out });
            return out;
        };
    };

    const alarmLabel = (alarm) => (alarm && ((alarm.groupName && alarm.groupName.trim()) ||
        (alarm.alarmName && alarm.alarmName.trim()))) || '';
    const activatedLabel = (alarm) => (alarm && alarm.alarmName && alarm.alarmName.trim()) || '';

    vm.uniqueAlarms = buildUniqueMemo(alarmLabel);
    vm.uniqueActivatedAlarms = buildUniqueMemo(activatedLabel);
}
